/*
 * @Description: 登录接口管理文件
 * @Author: 王振
 * @Date: 2021-07-06 15:30:43
 * @LastEditors: 王振
 * @LastEditTime: 2021-08-09 14:22:53
 */
//导入http
import http from "../utils/http";

/**
 * @description: 用户登录
 * @param {*} params 用户登录请求参数，账号和密码
 * @return 返回请求登录接口的结果
 */
export function postLoginAPI(params) {
  return http.postparams("/biz/login", params);
}

/**
 * @description: 获取用户信息
 * @param {*}
 * @return {*}
 */
export function getUserAPI() {
  return http.get("/biz/user");
}

/**
 * @description: 系统登出
 * @param {*} params
 * @return {*}
 */
export function postLogoutAPI(params) {
  return http.post("/biz/logout", params);
}

/**
 * @description: 修改密码
 * @param {*} params 用户修改密码请求参数，用户id和旧密码，新密码
 * @return {*}
 */
export function postCheckPassAPI(params) {
  return http.postparams("/biz/updatePass", params);
}



// WEBPACK FOOTER //
// ./src/api/login.js